import React, { useState, useEffect, useCallback, useMemo } from "react";
import DataFetchHookOI from "../../helper/DataFetchHookOI";
import PermissionsRequired from "../../helper/PermissionsRequired";
import moment from "moment";
import { Table, PageHeader, Button, Card, Form, Select, Row, Col, Input} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import AssociationsChecker from "./../../helper/AssociationsChecker";
import axios from "axios";
import Cookies from "js-cookie";
import { OI_URL, API_BASE_URL } from "../../config/config";
import ExportModalV3 from "../../helper/ExportModalV3";
import CustomPaginationV2 from "../../helper/Table/CustomPaginationV2";
import CustomDateRangeV3 from "../../helper/Table/CustomDateRangeV3";
import SortOrder from "../../helper/Table/SortOrder";
import ColumnResizable from "../../helper/Table/ColumnResizable";
import createExportDateHandler from "../../helper/createExportDateHandler";
import useDraggableModal from "./hooks/useDraggableModal";

const { Option } = Select;

const DATA_URL = "/api/v1/txshield/lookupHistory/";
const DATA_URL_EXPORT = API_BASE_URL + "/v3/txfind/lookupreports/";
const MERCHANT_DATA_URL = "/api/v1/txshield/merchants/";    
// const MERCHANT_DESCRIPTOR_DATA_URL = "/api/v1/txshield/descriptors/";

const MAX_DATERANGE = 3;
const START_DATE = moment().subtract(MAX_DATERANGE, "months");
const END_DATE = moment();

const LookupHistory = (props) => {

    const defaultSortInfo = {
        columnKey: "lookupDate",
        field: "lookupDate",
        order: "descend",
    };

    // initializing request data
    const oiAssociation = (Cookies.get("oiAssociation") || "").split(",").filter(item => item.trim() !== "");
    const initFormData = {
        keyword: null,
        field: "txShieldOICartReference",
        // order: null,
        associatedMerchantIds: oiAssociation, 
        descriptor: null,
        dateFrom: START_DATE,
        dateTo: END_DATE,
        page: 1,
        size: 20,
        order: "DESC",
        sortField: "dateCreated",
        startDate: null,
        endDate: null,
    };

    const [{ data, totalResult, isLoading, isError, errorMsg, requestData }, doFetch, setRequestData] = DataFetchHookOI(DATA_URL, "POST", null, initFormData); // eslint-disable-line
    const [formData, setFormData] = useState({ hideColumn: [] });
    const [form] = Form.useForm();
    const [sortedInfo, setSortedInfo] = useState({});
    const [dates, setDates] = useState([START_DATE, END_DATE]);
    const [currentPage, setCurrentPage] = useState(1);
    const [merchantList, setMerchantList] = useState([]);
    // const [descriptorList, setDescriptorList] = useState(null); // no use now
    // const [selectedDescriptor, setSelectedDescriptor] = useState(null);
    const { t } = props;
    const { ModalComponent, getButtonModal } = useDraggableModal(t);
    const [isDateExceeded, setIsDateExceeded] = useState(false); 
    const [exportRequestData, setExportRequestData] = useState({});

    useEffect(() => {
        formValInit();
        getMerchantList();
        // getDescriptorList();
        // getExportData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setExportRequestData({ ...requestData, token: Cookies.get("txfind_token")});
    }, [requestData]);

    const getMerchantList = useCallback(async () => {
        try {
            const response = await axios.post(
                OI_URL + MERCHANT_DATA_URL,

                { associatedMerchantIds: oiAssociation, order: 'ASC', sortField: 'name', page: 1, size: 1000 },
                { headers: { Authorization: "Bearer " + Cookies.get("txfind_token") } }
            );

            if (response.data && Array.isArray(response.data.datalist)) {
                setMerchantList(response.data.datalist);
            } else {
                console.warn("No valid merchant list found in the response");
                setMerchantList([]);
            }
        } catch (error) {
            console.error("Error fetching merchant list:", error);
            setMerchantList([]);
        }
    }, [oiAssociation]);

    // const getDescriptorList = useCallback(async () => {
    //     try {
    //         const response = await axios.post(
    //             OI_URL + MERCHANT_DESCRIPTOR_DATA_URL,
    //             { associatedMerchantIds: oiAssociation },
    //             { headers: { Authorization: "Bearer " + await Cookies.get("txfind_token") } }
    //         );

    //         if (response.data && Array.isArray(response.data.datalist)) {
    //             setDescriptorList(response.data.datalist);
    //         } else {
    //             console.warn("No valid descriptor list found in the response");
    //             setDescriptorList([]);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching descriptor list:", error);
    //         setDescriptorList([]);
    //     }
    // }, [oiAssociation]);

    const handleChange = (pagination, filters, sorter, { currentDataSource }) => {

        if (pagination.current === currentPage && pagination.pageSize === requestData.size) {
            const activeSorter = sorter.column ? sorter : defaultSortInfo;
            setSortedInfo(activeSorter);

            if (activeSorter && activeSorter.field) {
                const sortField = activeSorter.field;
                const sortOrder = activeSorter.order === "descend" ? "DESC" : "ASC";

                // Reset to page 1 when sorting changes
                setCurrentPage(1);

                // Preserve date filters when sorting
                const currentRequestData = { ...requestData };

                setRequestData({
                    ...currentRequestData,
                    page: 1, // Always reset to page 1 when sorting changes
                    sortField: sortField,
                    order: sortOrder,
                });
            }
        }
    };

    const formValInit = () => {
        setFormData(initFormData);
        form.setFieldsValue(initFormData);
    };

    const formValChange = (chgV, allV) => {
        setFormData(allV);
    };

    // Update the clearAll function to preserve merchant associations
    const clearAll = () => {
        // Get user's merchant associations
        const isSysAdmin = PermissionsRequired("SYSADMIN");
        // Create reset data that preserves associations for non-SysAdmin users
        const resetData = { ...initFormData };
        if (!isSysAdmin && oiAssociation.length > 0) {
            resetData.associatedMerchantIds = oiAssociation;
        }

        setFormData(resetData);
        setRequestData({
            ...requestData,
            ...resetData,
            startDate: null,
            endDate: null,
            page: 1,
            size: parseInt(requestData.size) || 20,
            sortField: "lookupDate",
            order: "DESC",
        });
        form.setFieldsValue(resetData);
    };

    const [columnsState, setColumnsState] = useState([
        { key: "txShieldOICartReference", width: 250 },
        { key: "lookupReference", width: 250 },
        { key: "lookupDate", width: 180 },
        { key: "provider", width: 100 },
        { key: "service", width: 100 },
        { key: "receivedData", width: 130 },
        { key: "returnData", width: 130 },
    ]);

    const columns = useMemo(
        () => {
            const handleResize =
                (index) =>
                (_, { size }) => {
                    const next = [...columnsState];
                    next[index] = { ...next[index], width: size.width };
                    setColumnsState(next);
                };
                
            return [
            {
                dataIndex: "txShieldOICartReference",
                key: "txShieldOICartReference",
                title: t("tables.fields.txshieldoicartreference"),
                width: columnsState[0].width,
                render: (txShieldOICartReference) => (txShieldOICartReference ? txShieldOICartReference : ""),
                // sorter: {
                //     compare: (a, b) => (a?.txShieldOICartReference || "").localeCompare((a?.txShieldOICartReference || "")),
                // },
                sorter: true,
                sortOrder: SortOrder(sortedInfo, "txShieldOICartReference"),
                onHeaderCell: () => ({
                    width: columnsState[0].width,
                    onResize: handleResize(0),
                }),
            },
            {
                dataIndex: "lookupReference",
                key: "lookupReference",
                title: t("tables.fields.lookupreference"),
                width: columnsState[1].width,
                // sorter: {
                //     compare: (a, b) => a.lookupReference.localeCompare(b.lookupReference),
                // },
                sorter: true,
                sortOrder: SortOrder(sortedInfo, "lookupReference"),
                onHeaderCell: () => ({
                    width: columnsState[1].width,
                    onResize: handleResize(1),
                }),
            },
            {
                dataIndex: "lookupDate",
                key: "lookupDate",
                title: t("tables.fields.lookupdate"),
                width: 180,
                render: (lookupDate) => moment(lookupDate).format("YYYY-MM-DD HH:mm:ss"),
                sorter: true,
                defaultSortOrder: "descend",
                sortOrder: SortOrder(sortedInfo, "lookupDate"),
            },
            {
                dataIndex: "provider",
                key: "provider",
                title: t("tables.fields.provider"),
                width: 100,
                // sorter: {
                //     compare: (a, b) => a.provider.localeCompare(b.provider),
                // },
                sorter: true,
                sortOrder: SortOrder(sortedInfo, "provider"),
            },
            {
                dataIndex: "service",
                key: "service",
                title: t("tables.fields.service"),
                width: 100,
                render: (service) => (service ? service : ""),
                // sorter: {
                //     compare: (a, b) => a.service.localeCompare(b.service),
                // },
                sorter: true,
                sortOrder: SortOrder(sortedInfo, "service"),
            },
            {
                dataIndex: "receivedData",
                key: "receivedData",
                align: "left",
                title: t("tables.fields.receiveddata"),
                width: 130,
                render: (receivedData, record) => (receivedData ? getButtonModal({ title: t("contents.oi.received_data"), content: receivedData }) : ""),
            },
            {
                dataIndex: "returnData",
                key: "returnData",
                align: "left",
                title: t("tables.fields.returndata"),
                width: 130,
                render: (returnData, record) => (returnData ? getButtonModal({ title: t("contents.oi.return_data"), content: returnData }) : ""),
            },
        ]},
        [columnsState, sortedInfo, t, getButtonModal]
    ); // eslint-disable-line react-hooks/exhaustive-deps

    // const onDescriptorDropdownChange = async (value) => {
    //     setSelectedDescriptor(value);
    // };

    const getDataSource = (datalist) =>
        datalist && Array.isArray(datalist)
            ? datalist.map((data) => ({
                  ...data,
                  txShieldOICartReference: data.txShieldOICartReference || "",
                  lookupReference: data.lookupReference || "",
                  provider: data.provider || "",
              }))
            : [];

    // Update the onFinish function to ensure merchant associations are preserved
    const onFinish = () => {
        // Get user's merchant associations
        const isSysAdmin = PermissionsRequired("SYSADMIN");
        let startDate = null;
        let endDate = null;
        let searchData = {};

        if (formData) {
            if (dates) {
                startDate = dates[0] ? dates[0] : null;
                endDate = dates[1] ? dates[1] : null;
            }

            // Determine which merchant IDs to use
            let merchantIds = formData.associatedMerchantIds && formData.associatedMerchantIds.length > 0 ? formData.associatedMerchantIds : [];

            // For non-SysAdmin, ensure we use their associated merchants if none are selected
            if ((!merchantIds || merchantIds.length === 0) && !isSysAdmin && oiAssociation.length > 0) {
                merchantIds = oiAssociation;
            }

            searchData = {
                value: [formData.keyword ? formData.keyword.trim() : null],
                field: [formData.field],
                operator: [formData.field === "txShieldOICartReference" ? "=" : "LIKE"],
                order: formData.order,
                sortField: sortedInfo.field || "dateCreated",
                associatedMerchantIds: merchantIds,
                descriptor: formData.descriptor,
            };
        }

        setCurrentPage(1);
        setRequestData({
            ...requestData,
            ...searchData,
            dateFrom: startDate,
            dateTo: endDate,
            page: 1,
        });
    };

    /**
     * callback to reflect the changes on dates to the passing request data
     * 
     * @param array values 
     */
    const handleDateChange = createExportDateHandler(requestData);

    const AdvancedSearchForm = () => (
        <div className="search-wrap">
            <Card title={t("tables.actions.search")} size="small">
                <Form form={form} size="large" name="advanced_search" className="ant-advanced-search-form" onValuesChange={formValChange} onFinish={onFinish}>
                    <Row gutter={[16, 16]}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                            <Form.Item
                                name="dateRange"
                                rules={[
                                    {
                                        validator: () => {
                                            if (isDateExceeded) {
                                                return Promise.reject(t("max_3_months"));
                                            } else if ((dates[0] && !dates[1]) || (!dates[0] && dates[1])) {
                                                return Promise.reject(t("min_1_day"));
                                            } else {
                                                return Promise.resolve();
                                            }
                                        },
                                    },
                                ]}
                            >
                                <CustomDateRangeV3
                                    t={t}
                                    setIsDateExceeded={setIsDateExceeded}
                                    state={{ dates, setDates }}
                                    unit="months"
                                    limit={MAX_DATERANGE}
                                    onChange={handleDateChange}
                                />
                            </Form.Item>
                        </Col>
                        {merchantList ? (
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                                <Form.Item name="associatedMerchantIds">
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        showArrow="true"
                                        maxTagCount="responsive"
                                        style={{ width: "100%" }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                        filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        placeholder={t("contents.oi.advanced_search.merchant")}
                                    >
                                        {merchantList.map((item) => (
                                            <Option key={item.merchantId} value={item.merchantId}>
                                                {item.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        ) : null}
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 5 }}>
                            <Form.Item name="field">
                                <Select showSearch style={{ width: "100%" }} placeholder={t("tables.fields.field")}>
                                    <Option value="txShieldOICartReference">{t("contents.oi.advanced_search.txshieldoicartreference_field")}</Option>
                                    <Option value="service">{t("contents.oi.advanced_search.service")}</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 7 }}>
                            <Form.Item name="keyword">
                                <Input placeholder={t("tables.fields.keyword")} />
                            </Form.Item>
                        </Col>
                        {/*descriptorList ? (
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                                <Form.Item name="descriptor">
                                    <Select
                                        value={selectedDescriptor}
                                        onChange={onDescriptorDropdownChange}
                                        showSearch
                                        style={{ width: "100%" }}
                                        placeholder={t("contents.oi.advanced_search.descriptor")}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {descriptorList.map((item) => (
                                            <Option key={item.title} value={item.title}>
                                                {item.title}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        ) : null  */}
                        {/*
                        <Col className="gutter-row" span={4}>
                            <Form.Item name="order">
                                <Select style={{ width: "100%" }} placeholder="Order">
                                    <Option value="ASC">ASC</Option>
                                    <Option value="DESC">DESC</Option>
                                </Select>
                            </Form.Item>
                        </Col> */}
                        <Col
                            className="gutter-row"
                            xs={{ span: 24 }}
                            sm={{ span: 12 }}
                            md={{ span: 6 }}
                            lg={{ span: 4, offset: 0 }}
                            xl={{ span: 3, offset: 11 }}
                        >
                            <Form.Item>
                                <Button type="secondary" onClick={() => clearAll()} block>
                                    {t("tables.actions.clear_all")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block>
                                    <SearchOutlined /> {t("tables.actions.search")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );

    const exportHeadersOptional = [];
    const exportHeaders = [
        { label: "TxFind Cart Reference", key: "txShieldOICartReference" },
        { label: "Lookup Reference", key: "lookupReference" },
        { label: "Lookup Date", key: "lookupDate" },
        { label: "Provider", key: "provider" },
        { label: "Service", key: "service" },
        { label: "Received Data", key: "receivedData" },
        { label: "Return Data", key: "returnData" },
    ];

    const getHeaderTable = () => (
        <div className="custom-table--header d-flex justify-content-between align-items-center">
            <h3 className="table-title">{t("contents.oi.lookup_history")}</h3>
            <ExportModalV3
                t={t}
                keyname="export_all"
                title={t("tables.actions.export")}
                data={exportRequestData}
                data_url={DATA_URL_EXPORT}
                headers={exportHeaders}
                fieldHeadersOptional={exportHeadersOptional}
                filename={`txfind_cart_lookup_${moment().format("YYMMDD_HHmmss_SSSS")}.csv`}
                style={{ marginLeft: 8 }}
            />
        </div>
    );

    return PermissionsRequired("SYSADMIN") || AssociationsChecker("OI") ? (
        <div>
            <PageHeader title={t("contents.oi.lookup_history")}></PageHeader>
            {ModalComponent}
            {AdvancedSearchForm()}
            <Table
                title={() => getHeaderTable()}
                loading={isLoading}
                components={{
                    header: {
                        cell: ColumnResizable,
                    },
                }}
                columns={columns}
                rowKey="lookupDate"
                scroll={{ x: 1200 }}
                className="table-v3 custom-pagination"
                size="small"
                dataSource={getDataSource(data.datalist)}
                onChange={handleChange}
                pagination={CustomPaginationV2({ totalResult, currentPage, requestData, setRequestData, setCurrentPage })}
            />
        </div>
    ) : null;
};

export default LookupHistory;
